import Link from "next/link";
import {ImageWithFallback} from "@/components";
import {isEmpty} from "@/utils/global-functions";
import moment from "moment-jalaali";
moment.loadPersian({dialect: "persian-modern"})

export default function MarkedArticleCard({title = "", image = "", category = {}, url = "/", time = ""}) {

    return (
        <div className="group relative w-full block">
            <Link href={url}
                  className="absolute w-full h-full left-0 top-0 z-20 rounded-tl-[1.75rem] rounded-tr-[2.688rem]"/>
            <div className="relative">
                <div className="relative w-full h-[20.625rem] rounded-l-[1.75rem] rounded-r-[2.688rem] overflow-hidden">
                <span
                    className="absolute left-0 top-0 h-full w-full z-10 duration-300 opacity-0 group-hover:opacity-100"
                    style={{background: "linear-gradient(35deg, rgba(59,24,183,0.76) 0%, rgba(86,27,231,0.19) 40%, rgba(100,29,255,0) 87%)"}}/>
                    <ImageWithFallback
                        src={image}
                        alt={title}
                        fill
                        className="object-cover"
                    />
                </div>
                <div
                    className="bg-white h-[3.25rem] absolute -bottom-7 left-10 rounded-t-[1.188rem] min-w-[10.375rem] z-10">
                    <div
                        className="relative flex items-center text-pol-light-brown font-semibold text-sm  w-full h-full px-4">
                        <div className="triangle triangle-r-md triangle-r-white absolute -right-[23px] -bottom-px"/>
                        <div className="triangle triangle-l-md triangle-l-white absolute -left-[23px] -bottom-px"/>
                        <i className="icon-calendar text-lg mb-1 ml-2"/>
                        <time>{moment(time).format("jD jMMMM jYYYY")}</time>
                    </div>
                </div>
            </div>

            <div className="mt-4 pr-2.5 pb-1">
                <Link href={`/blog/category/${!isEmpty(category) ? category.slug : ""}`}
                      className="relative z-30 inline-flex items-center text-sm text-pol-blue lg:text-pol-light-brown lg:hover:text-pol-blue duration-300">
                    <i className="icon icon-opened-folder ml-2.5"/>
                    <p className="font-semibold">{!isEmpty(category) ? category.title : ""}</p>
                </Link>
                <h2 className="mt-3 font-bold text-lg text-pol-gray-600 truncate max-w-full w-full group-hover:text-pol-dark duration-300">{title}</h2>
            </div>
        </div>
    )
}
